/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DsaiIngestionProgressStatus {
    PROCESSING = 'processing',
    COMPLETE = 'complete',
    CANCELLED = 'cancelled',
    ERROR = 'error',
}
